var render, staticRenderFns
import script from "./KButtonGroup.vue?vue&type=script&lang=js"
export * from "./KButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./KButtonGroup.vue?vue&type=style&index=0&id=0b95108e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b95108e",
  null
  
)

export default component.exports